import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowActive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "3---Process-Definition",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "3-1-0-d-Process-Definition-[Scanning]-",
			transform: "translate(-120.000000, -114.000000)",
			fill: "#171D29",
			children: /* @__PURE__ */ _jsx("g", {
				id: "master/back",
				transform: "translate(120.000000, 114.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "icons/icons24/arrows/arrow-black",
					children: /* @__PURE__ */ _jsx("polygon", {
						id: "Path",
						points: "11.0040105 6 5 11.9999855 11.0020073 18 11.7090053 17.295004 6.91400115 12.4999915 19 12.4999915 19 11.5000085 6.91400115 11.5000085 11.7110084 6.70299288"
					})
				})
			})
		})
	})
});
export default SvgArrowActive;
